// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","transparentPricing":"transparentPricing_transparentPricing__ZVoAS","divider":"transparentPricing_divider__h6Xuy"};